module.exports = __webpack_public_path__ + "assets/img/slow_cook.559684ca.png";